"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
require("./index.scss");
const react_1 = __importDefault(require("react"));
const NewUserHeader = () => (react_1.default.createElement("div", { className: "new-user-scene-header" },
    react_1.default.createElement(ContentHeader_1.default, { title: "Welcome! Let\u2019s Customize Your Experience", descriptionElement: react_1.default.createElement("p", null, "To help us provide the best tools and insights for you, please choose the option below that fits your role. Whether you\u2019re a songwriter or someone who manages royalties, selecting the right option ensures you get the most out of your experience.") })));
exports.default = NewUserHeader;
